import { noPropagate, noDefault } from '../../utils'

export const flatten = (tree, ancestors = []) =>
  tree.reduce(
    (prev, cur) => [
      ...prev,
      {
        ...cur,
        ancestors,
      },
      ...flatten(cur.childOptions || [], ancestors.concat(cur)),
    ],
    []
  )

export const findCurrentTree = (currentPath, rootTree) => {
  const path = currentPath || []
  const depth = path.length
  let tree = rootTree

  for (let i = 0; i < depth; i += 1) {
    tree = tree.find((subtree) => subtree.id === path[i])
    if (tree.childOptions) {
      tree = [tree, ...tree.childOptions]
    }
  }
  return tree
}

export const stopped = (method) => (e) => noPropagate(noDefault(method(e)))
